import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "inherit",
      d: "M15.688 1.108a1 1 0 0 0-.016-.143V.888c0-.038-.022-.073-.035-.108-.012-.035-.017-.067-.03-.1-.012-.032-.017-.03-.024-.047A2 2 0 0 0 15.5.5l-.04-.05q-.048-.061-.1-.12a.4.4 0 0 0-.06-.047 1 1 0 0 0-.105-.085l-.093-.05-.1-.05c-.035-.015-.072-.023-.11-.035l-.097-.028a1 1 0 0 0-.14 0h-4.548a1.117 1.117 0 1 0 0 2.233h1.83L8.57 5.71 6.383 3.565a1.12 1.12 0 0 0-.808-.315 1.1 1.1 0 0 0-.792.358L.298 8.448a1.117 1.117 0 0 0 1.637 1.517l3.705-4 2.17 2.13a1.13 1.13 0 0 0 1.223.227c.135-.058.258-.143.36-.25l4.062-4.197v1.708a1.117 1.117 0 0 0 2.233 0z",
      class: "fill-secondary"
    }, null, -1),
    _createElementVNode("path", {
      fill: "inherit",
      d: "M15.07 14.14h-.82v-4.8a.934.934 0 0 0-1.3-.905.93.93 0 0 0-.562.905v4.8h-1.675v-2.557a.93.93 0 0 0-1.86 0v2.557H7.25v-3.805a.93.93 0 0 0-1.86 0v3.805H3.808v-2.5a.93.93 0 0 0-1.86 0v2.5h-.83a.93.93 0 0 0 0 1.86H15.07a.93.93 0 1 0 0-1.86",
      class: "fill-primary"
    }, null, -1)
  ])))
}
export default { render: render }